var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.11806 18.2518C15.1119 18.2518 19.4833 11.4611 19.4833 5.57281C19.4833 5.37985 19.4795 5.18776 19.4708 4.99671C20.3193 4.36778 21.057 3.58299 21.6389 2.68943C20.8601 3.04407 20.0222 3.28317 19.1431 3.3909C20.0404 2.83938 20.7292 1.96641 21.0541 0.925932C20.2142 1.43635 19.2845 1.80759 18.2946 2.00751C17.5016 1.1414 16.3721 0.599609 15.1224 0.599609C12.7221 0.599609 10.7758 2.59534 10.7758 5.05553C10.7758 5.40531 10.814 5.74527 10.8885 6.07159C7.27668 5.88541 4.07386 4.11209 1.93061 1.41576C1.55703 2.07414 1.34207 2.83938 1.34207 3.65545C1.34207 5.20157 2.1093 6.56638 3.27596 7.36481C2.56321 7.34231 1.89341 7.14144 1.30767 6.8073C1.30665 6.82589 1.30665 6.84457 1.30665 6.86412C1.30665 9.02257 2.80494 10.8243 4.79331 11.2329C4.42838 11.3347 4.04421 11.3896 3.64767 11.3896C3.36772 11.3896 3.0954 11.3612 2.8307 11.3093C3.38399 13.0797 4.98828 14.3681 6.89064 14.4044C5.40295 15.5996 3.52922 16.3118 1.49306 16.3118C1.14236 16.3118 0.796492 16.2913 0.456299 16.2501C2.37976 17.514 4.66342 18.2518 7.11806 18.2518Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.8887,
    height: 17.98,
    fill: "white",
    transform: "translate(0.101318 0.599609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon-twitter.edce07728a0ed462f638ba26ddad3be6.svg";
export { ForwardRef as ReactComponent };